import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { motion } from "framer-motion";
import { DirectionContext } from "../App";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const Onboarding = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const { navigateTo } = useContext(DirectionContext);
  const location = useLocation();

  // 컴포넌트 마운트 시 모든 쿠키 삭제 후 URL 파라미터 추출하여 쿠키 설정
  useEffect(() => {
    // 모든 쿠키 삭제
    const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
      Cookies.remove(cookieName, { path: "/" });
    }

    // URL에서 ref와 refDetail 파라미터 추출
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get("ref");
    const refDetail = searchParams.get("refDetail");

    if (ref && refDetail) {
      // 추출한 값을 쿠키에 저장 (7일 유효기간)
      Cookies.set("referralSource", ref, { expires: 7, path: "/" });
      Cookies.set("referralDetail", refDetail, { expires: 7, path: "/" });
    }
  }, [location]);

  const handleOnboardingComplete = () => {
    navigateTo("/select");
  };

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <BackgroundImage
          src="/png/bg.png"
          alt="배경"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        />
        <Overlay />
        <Content variants={contentVariants} initial="initial" animate="in">
          <TextSection variants={textVariants}>
            {/* <MainTitle variants={textVariants}>
              SKT 유심 개인정보 유출 사고
              <br />
              집단소송 접수
            </MainTitle>
            <SubTitle variants={textVariants}>
              복잡한 절차 없이, 온라인으로 접수하세요
            </SubTitle> */}
          </TextSection>

          <ActionButtonWrapper>
            <ActionButton onClick={handleOnboardingComplete}>
              소송 접수하기
            </ActionButton>
          </ActionButtonWrapper>
        </Content>
      </Container>
    </PageBackground>
  );
};

// 애니메이션 변수
const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  out: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const contentVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: 0.2,
      staggerChildren: 0.1,
    },
  },
};

const textVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      staggerChildren: 0.1,
    },
  },
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  @media (min-width: 769px) {
    padding: 20px;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: 100vh;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 768px) {
    background-color: #f8fafc;
    border-radius: 20px;
    height: 700px;
    min-height: 700px;
    max-width: 470px;
    margin: 0 auto;

    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    padding: 20px;
  }
`;

const BackgroundImage = styled(motion.img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

  @media (min-width: 769px) {
    border-radius: 20px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1;

  @media (min-width: 769px) {
    border-radius: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  z-index: 2;
  width: 100%;
  height: 90%;
  position: relative;

  @media (max-width: 768px) {
    padding: 0 20px;
    min-height: 100vh;
  }

  @media (min-width: 769px) {
    min-height: 700px;
    padding: 60px 20px;
  }
`;

const TextSection = styled(motion.div)`
  margin-top: 120px;
  color: white;
  z-index: 2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  @media (min-width: 769px) {
    margin-top: 80px;
  }
`;

const MainTitle = styled(motion.h1)`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
  word-break: keep-all;
  color: white;
`;

const SubTitle = styled(motion.p)`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  word-break: keep-all;
  opacity: 0.9;
  color: white;
`;

const ActionButtonWrapper = styled.div`
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  max-width: 300px;

  @media (min-width: 769px) {
    bottom: 150px;
  }
`;

const ActionButton = styled(motion.button)`
  display: flex;
  width: 201px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 2px solid #cb351a;
  background-color: transparent;
  color: #ddcfb4;
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default Onboarding;
